export enum CashDeskCloseState {
    noControled = 1,
    controled = 2,
    observated = 3
}
